<template>
    <div class="hts-tabs">
        <div
            class="hts-tabs__container"
            :class="cClass">
            <div>
                <div class="">
                    <nav
                        class="tabs"
                        aria-label="Tabs">
                        <p
                            v-for="(item, index) in items"
                            v-show="checkPermission(item.permissions || [], item.justOnePermission)"
                            :key="item[props.keyId]"
                            style="transition: width 2s ease-in-out"
                            @click="handleTabClick(item)">
                            <hts-link
                                class="w-full tab-item"
                                :class="'bg-active'"
                                :to="linkTo(item)"
                                :active="checkActiveRoute(item)">
                                <component
                                    :is="item[props.keyIconName]"
                                    :class="props.textStyle"
                                    class="icon"
                                    aria-hidden="true" />
                                <span
                                    v-if="showLabel"
                                    class="title"
                                    :class="props.textStyle">
                                    {{ $t(item[props.keyLabel]) }}
                                </span>
                            </hts-link>
                        </p>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { checkPermission } from '@/utils/permission-check'
import colorSize from '~/components/color-size'

const props = defineProps({
  keyId: {
    type: String,
    default: 'key'
  },
  keyLabel: {
    type: String,
    default: 'name'
  },
  keyIconName: {
    type: String,
    default: 'icon'
  },
  keyHref: {
    type: String,
    default: 'href'
  },
  items: {
    type: Object,
    required: true
  },
  size: {
    type: String,
    default: 'default'
  },
  color: {
    type: String,
    default: 'default'
  },
  checkActive: {
    type: Boolean,
    default: false
  },
  textStyle: {
    type: String,
    default: ''
  },
  showLabel: {
    type: Boolean,
    default: true
  }
})
const { cClass } = colorSize(props)
const { items } = toRefs(props)
const selected = ref('')
const route = computed<string>(() => useRoute().name as string)
const handleTabClick = (item: { [key: string]: any }) => {
  selected.value = item.route && item.route.name

  const redirect = $lodash.get(item, 'route.redirect')

  if (!$lodash.isNil(redirect)) {
    useRouter().push({
      name: redirect,
      params: {}
    })
  }
}

const linkTo = (item: { [key: string]: any }) => {
  // chuyển hướng đến tab đầu tiên có quyền
  if (item.tabChildren) {
    for (const tab of item.tabChildren) {
      if (checkPermission(tab.permissions)) {
        return {
          ...tab.route,
          params: item.params || {}
        }
      }
    }
  }

  return {
    ...$lodash.get(item, 'route'),
    params: item.params || {}
  }
}

const checkActiveRoute = (item: { [key: string]: any }) => {
  if (!item.group || typeof route.value !== 'string') {
    return false
  }
  return route.value.includes(item.group)
}
</script>
